import { initializeFaro, getWebInstrumentations, ReactIntegration } from '@grafana/faro-react';
import packageJson from '../../package.json';
const FARO_PROD_DOMAIN = 'faro-collector.gjensidige.io';
const FARO_TEST_DOMAIN = 'faro-collector.testgjensidige.io';

const isProduction = window.location.host === "www.gjensidige.se";

const faroDomain = isProduction ? FARO_PROD_DOMAIN : FARO_TEST_DOMAIN;

export const faro = initializeFaro({
  url: `https://${faroDomain}/collect`,
  instrumentations: [
    ...getWebInstrumentations({ captureConsole: false }),
    new ReactIntegration()
  ],
  app: {
    name: 'sales-webshop-se',
    version: packageJson?.version || '1.0.0',
    environment: 'open',
  },
});
